// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalLinks_container__1MxQa","link":"ExternalLinks_link__26VXb","logo":"ExternalLinks_logo__3S7qt"};